require('/ui/components/table/body/celllink.module.scss.module.css');

export const cellLink = "_cell-link_1uv2a_1";
